import { SessionSotrageService } from "../../../services/session-sotrage.service";
export class AgregarPersona {
  public Persona: ModelPersona;

  public Cliente: ModelCliente;

  public Empleado: ModelEmpleado;

  public PersonaRelacionada: ModelPersonaRelacionada;

  public Usuario: ModelUsuario;

  public TipoPersona: number;

  public UsuarioId: number;
  //Mejores Práctivas v 2.1 inicio
  public CasoId: number;

  public ClienteId: number;
  // Mejores Practicas V 2.1 Cierre

  constructor(tipoPersona: any = 0) {
    // tslint:disable-next-line: no-use-before-declare
    this.Persona = new ModelPersona();
    // tslint:disable-next-line: no-use-before-declare
    this.Cliente = new ModelCliente();
    // tslint:disable-next-line: no-use-before-declare
    this.Empleado = new ModelEmpleado();
    // tslint:disable-next-line: no-use-before-declare
    this.PersonaRelacionada = new ModelPersonaRelacionada();
    // tslint:disable-next-line: no-use-before-declare
    this.Usuario = new ModelUsuario();

    if (tipoPersona == 1) this.Persona.PersonalidadFiscalId = 1;
    else this.Persona.PersonalidadFiscalId = -1;
    this.Persona.EstatusId = -1;
    this.Persona.EstadoId = -1;
    this.Persona.SexoId = -1;
    this.Persona.EstadoCivilId = -1;
    this.Cliente.ActividadEId = -1;
    this.Cliente.IngresoId = -1;
    this.Cliente.AntiguedadId = -1;
    this.Cliente.RiesgoId = 1;
    this.Cliente.SucursalId = -1;
    this.Cliente.Giro = "";
    this.Empleado.SucursalId = -1;
    this.Empleado.AreaId = -1;
    this.Empleado.PuestoId = -1;
    this.Empleado.ContratacionId = -1;
    this.TipoPersona = tipoPersona;
  }
}

export class ModelPersona {
  public Nombre: string;
  public SNombre: string;
  public ApellidoPaterno: string;
  public ApellidoMaterno: string;
  public PersonalidadFiscalId: number;
  public personalidadFiscal:string;
  public EstatusId: number;
  public EstadoId: number;
  public PaisId: number;
  public NacionalidadId: number;
  public RFC: string;
  public CURP: string;
  public Correo: string;
  public FechaNacimiento: string;
  public FechaRegistro: string;
  public ClaveCia: string;
  public FirmaElectronica: string;
  public EsPEP: boolean;
  public RelacionPEP: boolean;
  public EsLN: boolean;
  public PEP: boolean;
  public EsDocumentoFaltante:boolean;
  public SexoId: number;
  public EstadoCivilId: number;
  public UsuarioId: number;
  public PersonaId: number;
  public Abreviatura: string;
  public Latitud: number;
  public Longitud: number;
  public Fatca: boolean;
  //Mejores Práctivas v 2.1 inicio
  public CasoId: number;
  public ClienteId: number;
  public Origen: number;
  // Mejores Practicas V 2.1 Cierre
}

export class ModelEmpleado {
  public RiesgoId: number;
  public Profesion: string;
  public Titulado: boolean;
  public FechaIngreso: string;
  public ContratacionId: number;
  public Estatura: number;
  public SucursalId: number;
  public AreaId: number;
  public PuestoId: number;
  public Comite: boolean;
  public OficialCumplimiento: boolean;
}

export class ModelCliente {
  public RiesgoId: number;
  public ActividadEId: number;
  public IngresoId: number;
  public AntiguedadId: number;
  public SucursalId: number;
  public TipoEmpladoId:number;
  public CempresaNombre:string;
  public Giro: string;
}

export class ModelPersonaRelacionada {
  public PersonaId: number;
  public PersonaRelacionadaId: number;
  public ClienteId: number;
  public ParentescoId: number;
  public Porcentaje: number;
  public contrato:string;
  public ActividadEId:number;

  constructor() {
    this.ParentescoId = -1;
    this.Porcentaje = 0;
    this.ActividadEId = -1;
    this.contrato = '-1';
  }
}

export class ModelUsuario {
  public Login: string;
  public RolId: number;

  constructor() {
    this.RolId = -1;
  }
}

export class ModelEstados {
  public estadoId: number;
  public Estado: string;
  public abreviatura: string;
  public PaisId: number;
  public RiesgoId: number;
}
